import { i18n_t } from '@utils/i18n';

const $t = i18n_t;

export const getOverMauLimitMessage = () =>
    $t(
        'freeConstants.You_ve_exceeded_the_monthly_active_user__MAU__limit_of_your__nfree_Pendo_plan__To_gain_full_access_to_your_in_app_guides_and_n_data_analytics__upgrade_your_plan_today_',
    );

export const defaultAddress = Object.freeze({
    line1: '',
    line2: '',
    city: '',
    state: '',
    zip: '',
    country: '',
});

export const warningLimitPercentage = 0.8;

export const MAU_LIMIT_SUPPORT_ARTICLE_LINK = 'https://support.pendo.io/hc/en-us/articles/15968607780123';

export const freeMAULimit = 500;

export const starterMAULimit = 10000;

export const starter2024MAULimit = 40000;

export const STRIPE_API_KEYS = {
    prod: 'pk_live_51LUwCVCm3CE47mZDGCcFRekm5V9QFgpmfxkTwEnxlCT2kfAS75OdkHfurGIrp9EmA1GS8GNsY1G5NXmH36mKBwSX00AR5Uav0E',
    test: 'pk_test_51LUwCVCm3CE47mZDlIeyltea8IC1GtsrYPD2WvHvEBngAKI6vYJKfRnr6doDTavYzcVNPGJ0EVhThQnFrjxOL63u0019CjWYBX',
};

export const PADDLE_VENDOR_IDS = {
    prod: 157543,
    test: 8869,
};

export const FREE_PACKAGE = {
    planId: 'free',
    planName: 'free',
    price: null,
};

export const STARTER_PACKAGE = {
    planId: 'starter',
    displayName: 'Starter',
    availableCountries: ['*'],
    options: {
        annual: {
            id: 'starter_annual',
            planName: 'starter plan',
            mauTiers: [2000, 3500, 5000, 10000],
            price: 7000,
            paymentsPerYear: 1,
            pricePerMau: 3.5,
        },
        quarterly: {
            id: 'starter_quarterly',
            planName: 'starter plan (quarterly)',
            mauTiers: [2000, 3500, 5000, 10000],
            price: 2000,
            paymentsPerYear: 4,
            pricePerMau: 1,
        },
    },
};

export const STARTER_2024_PACKAGE = {
    planId: 'starter-2024',
    displayName: 'Starter',
    availableCountries: ['IN'],
    options: {
        annual: {
            id: 'starter_2024_annual',
            planName: 'starter package',
            mauTiers: [5000, 10000, 20000, 40000],
            price: 2500,
            paymentsPerYear: 1,
            pricePerMau: 0.5,
        },
        quarterly: {
            id: 'starter_2024_quarterly',
            planName: 'starter package (quarterly)',
            mauTiers: [5000, 10000, 20000, 40000],
            price: 750,
            paymentsPerYear: 4,
            pricePerMau: 0.15,
        },
    },
};

export const ENTERPRISE_PACKAGE = {
    planId: 'enterprise',
    showMoreDetailsEnabled: true,
    planName: 'enterprise',
    price: null,
};

export const RENEWAL_TERMS = {
    starter_annual: {
        version: 1.1,
        text:
            'I understand that my credit card will be charged on an annual basis for Pendo and I will receive reminders at least 7 days in advance of the charge.',
        updated: 'Jan 8, 2022',
    },
    starter_quarterly: {
        version: 2.1,
        text:
            'I understand that my credit card will be charged on a quarterly basis for Pendo and I will receive reminders at least 7 days in advance of the charge.',
        updated: 'Jan 8, 2022',
    },
    starter_monthly: {
        version: 3.1,
        text:
            'I understand that my credit card will be charged on a monthly basis for Pendo and I will receive reminders at least 7 days in advance of the charge.',
        updated: 'Jan 8, 2022',
    },
    starter_2024_annual: {
        version: 1.2,
        text:
            'I understand that my credit card will be charged on an annual basis for Pendo and I will receive reminders at least 7 days in advance of the charge.',
        updated: 'Feb 7, 2024',
    },
    starter_2024_quarterly: {
        version: 2.2,
        text:
            'I understand that my credit card will be charged on a quarterly basis for Pendo and I will receive reminders at least 7 days in advance of the charge.',
        updated: 'Feb 7, 2024',
    },
};

export const STARTER_2024_TERMS =
    'I am authorized to represent and warrant that my legal entity is incorporated and does business in the Republic of India.';

export const EXTERNAL_DEMO_SUB_IDS = ['4691349476737024'];

export const STEPS = {
    PLAN: 'Plan selection',
    INFO: 'Personal information',
    BILLING: 'Billing details',
    PAYMENT: 'Payment details',
    ERROR: 'Error',
};

export const CHECKOUT_STATES = {
    START: 'start',
    DETAILS: 'infoGathering',
    CONGRATULATIONS: 'congratulations',
    LOADING: 'loading',
    REJECTED: 'rejected',
};

export const STARTER_MAU_OPTIONS = [
    { count: 2000, label: '2,000' },
    { count: 3500, label: '3,500' },
    { count: 5000, label: '5,000' },
    { count: 10000, label: '10,000' },
    { count: 10001, label: '10,000+' },
];

export const STARTER_2024_MAU_OPTIONS = [
    { count: 5000, label: '5,000' },
    { count: 10000, label: '10,000' },
    { count: 20000, label: '20,000' },
    { count: 40000, label: '40,000' },
    { count: 40001, label: '40,000+' },
];

export const STARTER_2024_PRICE_PER_MAU_OPTIONS = {
    annual: {
        1: 0.7,
        5000: 0.7,
        10000: 0.65,
        20000: 0.6,
        40000: 0.5375,
        40001: 0.5375,
    },
    quarterly: {
        1: 0.2,
        5000: 0.2,
        10000: 0.19,
        20000: 0.18,
        40000: 0.16,
        40001: 0.16,
    },
};

export const MARKETO_FORM_IDS = Object.freeze({
    UPFRONT_TRIAL_30_DAYS: 3873,
});

export const UPGRADE_URL = 'https://www.pendo.io/?q_showExperience=experience-1733839747724';

export const UPFRONT_TRIAL_URL = 'https://www.pendo.io/?q_showExperience=experience-1733339901350';
